/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"

function CustomHtml({ html }) {
  const getHtml = () => {
    return { __html: `${html}` }
  }
  return <div sx={{ height: "fit-content", py: 9 }} dangerouslySetInnerHTML={getHtml()} />
}

export { CustomHtml }
